<template>
  <!-- 订单管理-订单管理 -->
  <div class="app-content">
    <AppPageTitle v-if="!isCom"></AppPageTitle>
    <Content class="app-content__main" :style="isCom?'padding:0;margin-top:-10px':''">
      <Form ref="formValidate" :model="formValidate" :label-width="120" v-if="!isCom">
        <Row>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="平台订单号:" prop="tradeNo">
              <Input v-model.trim="formValidate.tradeNo" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="代理商订单号:" prop="outTradeNo">
              <Input v-model.trim="formValidate.outTradeNo" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="用户:" prop="account">
              <Input v-model.trim="formValidate.account" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="供应商:" prop="supplierId">
              <Select v-model="formValidate.supplierId" clearable style="width: 100%;">
                <Option v-for="item in supplierList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="代理商:" prop="agentId">
              <Select v-model="formValidate.agentId" clearable style="width: 100%;">
                <Option v-for="item in agentList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="商品名称:" prop="commodityName">
              <Input v-model.trim="formValidate.commodityName" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="商品编号:" prop="commodityId">
              <Input v-model.trim="formValidate.commodityId" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="供应商商品编号:" prop="commodityNo">
              <Input v-model.trim="formValidate.commodityNo" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="代理商商品编号:" prop="agentCommodityId">
              <Input v-model.trim="formValidate.agentCommodityId" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="类型:" prop="rechargeType">
              <Select v-model="formValidate.rechargeType" clearable style="width: 100%;">
                <Option v-for="item in rechargeType" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="发券时间:">
              <DatePicker
                type="datetimerange"
                v-model="sendingData"
                format="yyyy-MM-dd HH:mm:ss"
                split-panels
                placeholder="请选择"
                style="width:100%" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="核销时间:">
              <DatePicker
                type="datetimerange"
                v-model="usageData"
                format="yyyy-MM-dd HH:mm:ss"
                split-panels
                placeholder="请选择"
                style="width:100%" />
            </FormItem>
          </Col>
          <Col :md='24' class="text-right">
            <Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 16px;">查询</Button>
            <Button type="default" @click="formReset" style="margin: 0 0 16px 0;">重置</Button>
          </Col>
        </Row>
      </Form>
      <Row v-if="!isCom">
        <Col :md='24' style="margin-bottom: 20px">
          <Button
            type="info"
            icon="md-download"
            style="margin-right: 8px"
            :disabled="!queryData.length"
            @click="exportOrder"
          >导出</Button>
          <Button
            type="info"
            icon="md-download"
            style="margin-right: 8px"
            :disabled="!queryData.length"
            @click="manualOrder"
          >手动下单(测试用)</Button>
        </Col>
      </Row>
      <Table
        :columns="queryColumn"
        :loading="loading"
        :data="queryData"
        border
        ref="dataTable"
      >
        <template slot-scope="{row}" slot="couponsStatus">
          <OrderStatus :node-state="row.nodeState" :tag-info="nodeState"></OrderStatus>
        </template>
        <template slot-scope="{row}" slot="writeOffStatus">
          <OrderStatus v-show="row.nodeState!==2" :node-state="row.notifyState" :tag-info="notifyState"></OrderStatus>
        </template>
        <template slot-scope="{row}" slot="op1">
          <Button
            type="text"
            class="text-link"
            size="small"
            @click="statusItem(row)"
          >查看明细</Button>
        </template>
      </Table>
      <Row>
        <Col :md="24" class="pagination">
          <Page
            :total="totalPage"
            :page-size="pageSize"
            :current="pageNum"
            :disabled="loading"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            show-elevator show-sizer show-total />
        </Col>
      </Row>
    </Content>
    <Modal
      title="订单详情"
      v-model="modal2"
      width="80%"
      class-name="vertical-center-modal">
      <order-item is-com :order-id="currentOrderId" ref="DetailRef" />
    </Modal>
    <ExportFile ref="exportFile" />
    <ManualOrder ref="manualOrder" @success="manualOrderSuccess"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '../../api'
import ExportFile from '../../components/common/ExportFile'
import OrderStatus from '@/components/order/OrderStatus.vue'
import ManualOrder from '@/components/order/ManualOrder.vue'
import OrderItem from '@/views/order/OrderItem.vue'

export default {
  components: {
    OrderItem,
    ExportFile,
    OrderStatus,
    ManualOrder
  },
  props: {
    isCom: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      modal2: false,
      formValidate: {
        tradeNo: null, // 平台订单号
        outTradeNo: null, // 代理商订单号
        account: null, // 用户
        agentId: null, // 代理商ID
        commodityName: null, // 商品名称
        commodityId: null, // 商品编号
        commodityNo: null, // 供应商商品编号
        agentCommodityId: null, // 代理商商品编号
        agentName: null, // 代理商名称
        rechargeType: null, // 商品类型
        nodeState: null, // 发券状态
        notifyState: null, // 核销状态
        sendingEndDate: null, // 发券时间开始
        sendingStartDate: null, // 发券时间结束
        usageEndDate: null, // 核销时间开始
        usageStartDate: null// 核销时间结束
      },
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1,
      currentOrderId: '',
      sendingData: [], // 发券开始结束时间
      usageData: [], // 核销开始结束时间
      supplierList: [], // 供应商下拉
      agentList: [] // 代理商下拉
    }
  },
  computed: {
    ...mapGetters(
      'recharge',
      ['rechargeType', 'rechargeMethodByValue', 'rechargeStatus', 'nodeState', 'notifyState']),
    queryColumn () {
      return [
        {
          title: '平台订单号',
          key: 'tradeNo',
          align: 'left',
          minWidth: 180
        },
        {
          title: '代理商订单号',
          key: 'outTradeNo',
          align: 'left',
          minWidth: 200
        },
        {
          title: '用户',
          key: 'account',
          align: 'center',
          minWidth: 150
        },
        {
          title: '代理商',
          key: 'agentName',
          align: 'center',
          minWidth: 130
        },
        {
          title: '商品名称',
          key: 'commodityName',
          align: 'center',
          minWidth: 150
        },
        {
          title: '发券状态',
          key: 'nodeState',
          minWidth: 120,
          align: 'center',
          slot: 'couponsStatus'
        },
        {
          title: '商品编号',
          key: 'commodityId',
          align: 'center',
          minWidth: 150
        },
        {
          title: '供应商商品编号',
          key: 'commodityNo',
          align: 'center',
          minWidth: 150
        },
        {
          title: '供应价格',
          key: 'unitCostPrice',
          minWidth: 130,
          align: 'center'
        },
        {
          title: '代理商价格',
          key: 'unitSalePrice',
          minWidth: 130,
          align: 'center'
        },
        {
          title: '创建时间',
          key: 'createDateStr',
          align: 'center',
          minWidth: 190
        },
        {
          title: '发券时间',
          key: 'sendingDateStr',
          align: 'center',
          minWidth: 190
        },
        {
          title: '核销状态',
          key: 'notifyState',
          minWidth: 80,
          align: 'center',
          slot: 'writeOffStatus'
        },
        {
          title: 'Action',
          key: 'action',
          width: 160,
          className: 'tableSlotRight',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'text',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.openDetails(params.row)
                  }
                }
              }, '查看明细')
            ])
          }
        }
      ]
    }
  },
  watch: {
    sendingData (val) {
      this.formValidate.sendingStartDate = val[0] ? val[0].getTime() : null
      this.formValidate.sendingEndDate = val[1] ? val[1].getTime() : null
    },
    usageData (val) {
      this.formValidate.usageStartDate = val[0] ? val[0].getTime() : null
      this.formValidate.usageEndDate = val[1] ? val[1].getTime() : null
    }
  },
  methods: {
    openDetails (row) {
      this.currentOrderId = row.id
      this.modal2 = true
      this.$refs.DetailRef.getData(row.id)
    },
    formSubmit () {
      this.pageNum = 1
      this.pageSize === 10 ? this.getData() : this.pageSize = 10
    },
    formReset () {
      this.$refs['formValidate'].resetFields()
      this.sendingData.splice(0)
      this.usageData.splice(0)
      this.$nextTick(() => {
        this.formSubmit()
      })
    },
    getData1(query) {
      this.formValidate.account = query.account
      this.formValidate.commodityId = query.commodityId
      this.getData()
    },
    getData () {
      this.loading = true
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          const element = this.formValidate[item]
          if (element !== '' && element !== null) {
            params[item] = this.formValidate[item]
          }
        }
      }
      params.pageNum = this.pageNum
      params.pageSize = this.pageSize
      api.order.rechargeList({
        ...params
      })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records.map(record => {
            Object.keys(record).forEach(e => {
              if (record[e] === '1970-01-01 08:00:00')record[e] = ''
            })
            return record
          }) || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取订单列表失败: ' + err.message)
        })
    },
    pageChange (pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },
    // 导出
    exportOrder () {
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          if (this.formValidate[item] !== '' && this.formValidate[item] !== null) {
            params[item] = this.formValidate[item]
          }
        }
      }
      params.pageNum = 1
      params.pageSize = 10
      this.$refs.exportFile.submit(api.order.outQueryOrder, 'get', {
        ...params
      })
    },
    // 手动购买
    manualOrder () {
      this.$refs.manualOrder.show()
    },
    // 购买成功
    manualOrderSuccess () {
      this.getData()
    }
  },
  created () {
    this.getData()
    // 获取供应商数据改造成下拉数据
    api.supplier.supplierList({
      pageNum: 1,
      pageSize: 100
    }).then((res) => {
      this.supplierList = res.data.records.map(item => ({
        value: item.id,
        label: item.name
      })) || []
    }).catch((err) => {
      this.$Message.error('获取供应商列表失败: ' + err.message)
    })
    // 获取代理商数据改造成下拉数据
    api.agent.agentList({
      pageNum: 1,
      pageSize: 100
    })
      .then((res) => {
        this.agentList = res.data.records
          .map(item => ({
            value: item.id,
            label: item.agentName
          })) || []
      })
      .catch((err) => {
        this.$Message.error('获取代理商列表失败: ' + err.message)
      })
  }
}
</script>

<style>

.ivu-table-body .ivu-table-cell{
  white-space: nowrap;
}

// 解决iview右定位错行问题
/deep/.ivu-table-tbody {
  position: relative;

  .tableSlotRight {
    position: sticky;
    right: 0;
    height: 50px !important;

    .ivu-table-cell {
      border-left: 1px solid #e8eaec;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
